import React from "react"
import styles from "./UserInfo.module.scss"
import classNames from "classnames"
import { ReactComponent as Pencil } from "../../images/icons/pencil.svg"
import Button from "../Button/Button"
import CustomTooltip from "../CompanyUserInfo/CustomTooltip"
import EmojiFlagsIcon from "@material-ui/icons/EmojiFlags"

const UserInfoShowInfo = ({
  handleEdit,
  anotherUser,
  dropdownData,
  onOpenChat,
  style,
  name,
  userType,
}) => {
  const isFreelancerProfile = anotherUser && userType === "freelancer"
  return (
    <>
      <div className={styles.userNameContainer}>
        <CustomTooltip name={name.showedName}>
          <h4
            className={classNames(
              style.userName,
              anotherUser && style.userNameWithoutIcon,
            )}
          >
            {name.showedName}
          </h4>
        </CustomTooltip>
        {!anotherUser && (
          <div
            className={classNames("iconWrap", styles.editIconWrap)}
            onClick={handleEdit}
          >
            <Pencil className="icon" />
          </div>
        )}
      </div>
      <div>
        <div className={style.userEducation}>
          {isFreelancerProfile ? (
            <h6 className={style.title}>
              {dropdownData.profession.showed.value || "—"}
            </h6>
          ) : (
            <>
              <h6 className={style.title}>
                {dropdownData.profession.showed.value}
              </h6>
              <h6 className={style.title}>
                {dropdownData.experience.showed.value}
              </h6>
              {dropdownData.industry.showed.databaseName !== "" && (
                <h6 className={style.title}>
                  {dropdownData.industry.showed.value}
                </h6>
              )}
              {dropdownData.gender.showed.databaseName !==
                "not_applicable_gender" && (
                <h6 className={style.title}>
                  {dropdownData.gender.showed.value}
                </h6>
              )}
              {dropdownData.race.showed.databaseName !==
                "not_applicable_race" && (
                <h6 className={style.title}>
                  {dropdownData.race.showed.value}
                </h6>
              )}
            </>
          )}
        </div>
        {anotherUser && (
          <Button
            width="100%"
            onClick={onOpenChat}
            className={styles.chatButton}
          >
            Chat
          </Button>
        )}
      </div>
    </>
  )
}

export default UserInfoShowInfo
